import * as currencyFormatter from 'currency-formatter';
import * as sha1 from 'js-sha1';

import { isEmpty, set } from 'lodash';

import ApiUrls from './apiUrls';
import AppData from './appData';
import i18next from 'i18next';
import losnavegadoresIcons from '../features/themes/functions/getIcons/navegadoresIcons';

var CryptoJS = require('crypto-js');

var global = window;
const seatIdentifiers = {
	'.GY': 'Gangway',
	'.DR_IMG': 'Driver Image',
	'.ST_IMG': 'Strairs Image',
	'.WR_IMG': 'Wash Room Image',
	'.BR': 'Break',
	GY: 'Gangway',
	DR_IMG: 'Driver Image',
	ST_IMG: 'Strairs Image',
	WR_IMG: 'Wash Room Image',
	BR: 'Break',
	SS: 'Semi Sleeper',
	LB: 'Lower Berth',
	UB: 'Upper Berth',
	BS: 'CLASICO',
	PB: 'CLASICO',
	NPB: 'CLASICO',
	SLB: 'CLASICO',
	SUB: 'CLASICO',
	SST: 'CLASICO',
	NA: 'CLASICO',
	ST: 'CLASICO',
	DLB: 'CLASICO',
	DUB: 'CLASICO',
	WSS: 'CLASICO',
	WST: 'CLASICO',
	WLB: 'CLASICO',
	WUB: 'CLASICO',
	WSL: 'CLASICO',
	WSU: 'CLASICOr',
	BU: 'CLASICO',
	EC: 'Semi Cama',
	'SEMI CAMA': 'SEMI CAMA',
	SEMI_CAMA: 'SEMI CAMA',
	'SALON CAMA': 'SALON CAMA',
	SALONCAMA: 'SALON CAMA',
	SALON_CAMA: 'SALON CAMA',
	CLASICO: 'Clasico',
	EJECUTIVO: 'Ejecutivo',
	PREMIUM: 'Premium',
	SC: 'Semi Cama',
	CO: 'CLASICO',
	EX: 'SALON CAMA',
	SP: 'CLASICO',
	SALON: 'SALON CAMA',
	'SALON MIXTO': 'SALON CAMA',
	SEMICAMA: 'SEMI CAMA',
	CAMA: 'SALON CAMA',
	COMUN: 'CLASICO',
	'COMUN CON AIRE': 'CLASICO',
	'Comun con Aire': 'CLASICO',
	SCA: 'CLASICO',
	Preferente: 'PREFERENTE',
	Salon: 'SALON CAMA',
	'Salon Sin Vent': 'SALON SIN VENT',
	'Cama Premium': 'CAMA PREMIUM',
	'CAMA PREMIUM': 'CAMA PREMIUM',
};

const getSeatType = (type, seatIds) => {
	// console.log('------------------types', type);
	// console.log('------------------seatIds', seatIds);
	let types = seatIds;
	return types[type];
};

const getAmenityName = rawAnemity => {
	// console.log('Raw amenity ---------', rawAnemity);
	switch (rawAnemity) {
		case 'mobile ticket':
			return 'RESULTS_PAGE.MOBILE_TICKET';
			break;
		case 'charging plug':
			return 'RESULTS_PAGE.CHARGING_PLUG';
			break;
		case 'wifi':
			return 'RESULTS_PAGE.WIFI';
			break;
		case 'movie':
			return 'RESULTS_PAGE.ENTERTAINMENT';
			break;
		case 'baggage':
			return 'RESULTS_PAGE.BAGGAGE';
			break;
		case 'restrooms':
			return 'RESULTS_PAGE.RESTROOMS';
			break;
		case 'air condtion':
			return 'RESULTS_PAGE.AIR_CONDITIONER';
			break;
		case 'snacks new':
			return 'RESULTS_PAGE.SNACKS';
			break;
		case 'coffee':
			return 'RESULTS_PAGE.COFFEE';
			break;
		default:
			return rawAnemity;
			break;
	}
};

const CommonService = {
	toast: {},
	formatData: jsonArr => {
		if (jsonArr) {
			let keys = jsonArr[0];
			let currArr = [];
			for (let i = 1; i < jsonArr.length; i++) {
				let currentObj = {};
				for (let j = 0; j < keys.length; j++) {
					currentObj[keys[j]] = jsonArr[i][j];
				}
				currArr.push(currentObj);
			}
			return currArr;
		}
	},
	formatCitiesTheme11: cities => {
		let formattedCities = [];
		for (let city of cities) {
			formattedCities.push({
				value: city[0],
				label: city[1],
				category: city[2],
			});
		}
		return formattedCities;
	},
	getSeatName: rawSeat => {
		// console.log('Raw seat comoon service', rawSeat);
		switch (rawSeat) {
			case 'SALON CAMA':
				return 'Salón Cama';
				break;
			case 'CLASICO':
				return 'Clásico';
				break;
			case 'Clasico':
				return 'Clásico';
				break;
			case 'clasico':
				return 'Clásico';
				break;
			case 'Salon Sin Vent':
				return 'Salón Sin Vent';
				break;
			case 'Salon Preferente':
				return 'Salón Preferente';
				break;
			case 'SALON SIN VENT':
				return 'Salón Sin Vent';
				break;
			case 'SALON PREFERENTE':
				return 'Salón Preferente';
				break;
			case 'SALON':
				return 'Salón ';
				break;
			case 'Salon':
				return 'Salón ';
				break;
			default:
				return CommonService.capitalize(rawSeat);
				break;
		}
	},
	capitalize: str => {
		// console.log('String to capppppp', str);
		if (str) {
			let strArr = str.split(' ');
			for (let i = 0; i < strArr.length; i++) {
				strArr[i] = strArr[i][0] && strArr[i][0].toUpperCase() + strArr[i].substr(1).toLowerCase();
			}
			return strArr.join(' ');
		}
		return '';
	},
	round: (number, digit) => {
		let p = Math.pow(10, digit);
		return Math.round(number * p) / p;
	},

	splitRutAndDv: rut => {
		let cValue = rut.replace(/[\.\-]/g, '');
		if (cValue.length == 0) return [null, null];
		if (cValue.length == 1) return [cValue, null];
		let cDv = cValue.charAt(cValue.length - 1);
		let cRut = cValue.substring(0, cValue.length - 1);
		return [cRut, cDv];
	},

	formatRut: value => {
		let rutAndDv = CommonService.splitRutAndDv(value);
		let cRut = rutAndDv[0];
		let cDv = rutAndDv[1];
		if (!(cRut && cDv)) return cRut || value;
		let rutF = '';
		while (cRut.length > 3) {
			rutF = '.' + cRut.substr(cRut.length - 3) + rutF;
			cRut = cRut.substring(0, cRut.length - 3);
		}
		return cRut + rutF + '-' + cDv;
	},

	isRutValid: rut => {
		if (typeof rut !== 'string') return false;
		let cRut = rut.replace(/[\.\-]/g, '');
		if (cRut.length < 2) return false;
		let cDv = cRut.charAt(cRut.length - 1).toUpperCase();
		let nRut = parseInt(cRut.substr(0, cRut.length - 1));
		if (nRut === NaN) return false;
		return (
			CommonService.computeDv(nRut)
				.toString()
				.toUpperCase() === cDv
		);
	},

	isRut: (type, idCardTypes) => {
		if (idCardTypes) {
			let cardType = idCardTypes.filter(t => {
				return t.id == type;
			});
			if (
				cardType &&
				cardType[0] &&
				cardType[0].name &&
				cardType[0].name.toLowerCase().indexOf('rut') > -1
			) {
				return true;
			}
		}
		return false;
	},

	computeDv: rut => {
		let suma = 0;
		let mul = 2;
		if (typeof rut !== 'number') return;
		rut = rut.toString();
		for (let i = rut.length - 1; i >= 0; i--) {
			suma = suma + rut.charAt(i) * mul;
			mul = (mul + 1) % 8 || 2;
		}
		switch (suma % 11) {
			case 1:
				return 'k';
			case 0:
				return 0;
			default:
				return 11 - (suma % 11);
		}
	},

	copyObject: ob => {
		if (!ob) return {};
		return JSON.parse(JSON.stringify(ob));
	},

	isEMailValid: email => {
		if (email) {
			if (email.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+$/)) {
				return true;
			} else {
				return false;
			}
		}
	},
	storeLoginDetails: (loginData, setLoginData, fromHome = false) => {
		global.token = loginData ? loginData.auth_token : null;
		if (loginData) {
			if (loginData.carpool_customer) {
				global.xAccess = loginData.carpool_customer.access_token;
			}
			if (loginData.carpool_driver) {
				global.driverXAccess = loginData.carpool_driver.access_token;
			}
		} else {
			global.xAccess = null;
			global.driverXAccess = null;
		}
		setLoginData(loginData);
		if (!fromHome)
			loginData
				? CommonService.setLocal('loginData', loginData)
				: CommonService.setLocal('loginData', {});
	},
	isLoggedIn: () => {
		if (!global.token) {
			return false;
		}
		return true;
	},
	logout: () => {
		global.token = null;
		CommonService.removeLocal('googleAccessToken');
		CommonService.removeLocal('loginData');
		localStorage.removeItem('selectedLanguage');
	},

	getStatusName: status => {
		let s = {
			confirmed: 'ConfirmadoII',
			booked: 'Reservados',
			cancelled: 'Anulado',
			pending: 'Pending',
			partial_cancelled: 'Canceledo Parcialmente',
		};
		return s[status];
	},

	phoneNumberFormat: (text, len = 9) => {
		if (text) {
			text = (text + '').replace(/[a-zA-Z]/g, '');
			if ((text + '').length > len) {
				text = (text + '').substr(0, len);
			}
		}
		return text;
	},

	onlyNumbers: text => {
		if (text) {
			text = (text + '').replace(/[^0-9]/g, '');
		}
		return text;
	},

	onlyChars: text => {
		if (text) {
			text = (text + '').replace(/[^a-zA-Z]/i, '');
		}
		return text;
	},

	onlyNumericValues: text => {
		if (text.match(/[^0-9]/g)) {
			return false;
		} else return true;
	},

	removeCommas: text => {
		let newText;
		text.map(val => (val != '' ? (newText = val) : null));
		return newText;
		// if(text)
		//   return text.replace (/,/g, "")
	},

	isEqual: (value, other) => {
		// Get the value type
		var type = Object.prototype.toString.call(value);

		// If the two objects are not the same type, return false
		if (type !== Object.prototype.toString.call(other)) return false;

		// If items are not an object or array, return false
		if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

		// Compare the length of the length of the two items
		var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
		var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
		if (valueLen !== otherLen) return false;

		// Compare two items
		var compare = function (item1, item2) {
			// Get the object type
			var itemType = Object.prototype.toString.call(item1);

			// If an object or array, compare recursively
			if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
				if (!CommonService.isEqual(item1, item2)) return false;
			}

			// Otherwise, do a simple comparison
			else {
				// If the two items are not the same type, return false
				if (itemType !== Object.prototype.toString.call(item2)) return false;

				// Else if it's a function, convert to a string and compare
				// Otherwise, just compare
				if (itemType === '[object Function]') {
					if (item1.toString() !== item2.toString()) return false;
				} else {
					if (item1 !== item2) return false;
				}
			}
		};

		// Compare properties
		if (type === '[object Array]') {
			for (var i = 0; i < valueLen; i++) {
				if (compare(value[i], other[i]) === false) return false;
			}
		} else {
			for (var key in value) {
				if (value.hasOwnProperty(key)) {
					if (compare(value[key], other[key]) === false) return false;
				}
			}
		}

		// If nothing failed, return true
		return true;
	},

	currency: amount => {
		let formattedAmount = currencyFormatter.format(amount, { code: 'CLP' });
		return (
			'$' +
			formattedAmount
				.replace('$', '')
				.trim()
				.split(',')[0]
		);
	},

	generateXAccess: (key, token) => {
		let timeNow = Math.floor(new Date().getTime() / 1000);
		let t = [timeNow, sha1.hex([key, token, timeNow].join(''))].join('.');
		return t;
	},
	preZero: n => {
		if (n > 9) {
			return n;
		}
		return '0' + n;
	},
	distance: ({ lat1, lon1, lat2, lon2, unit }) => {
		if (lat1 == lat2 && lon1 == lon2) {
			return 0;
		} else {
			var radlat1 = (Math.PI * lat1) / 180;
			var radlat2 = (Math.PI * lat2) / 180;
			var theta = lon1 - lon2;
			var radtheta = (Math.PI * theta) / 180;
			var dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == 'K') {
				dist = dist * 1.609344;
			}
			if (unit == 'N') {
				dist = dist * 0.8684;
			}
			if (unit == 'MT') {
				dist = dist * 1.609344 * 1000;
			}
			return dist;
		}
	},
	//   prefIcons: {
	//       'ciga': {icon:require('../assets/carpool/cigerette-circle.png'),name:'Fumador'},
	//       'music': {icon:require('../assets/carpool/music-circle.png'),name:'Música'},
	//       'only_girl': {icon:require('../assets/carpool/girl-circle.png'),name:'Solo mujeres'},
	//       'ac': {icon:require('../assets/carpool/ac-circle.png'),name:'A / C'},
	//       'luggage': {icon:require('../assets/carpool/luggage-circle.png'),name:'Equipaje'},
	//       'conversation': {icon:require('../assets/carpool/chat-circle.png'),name:'Conversación'},
	//       'front_seat': {icon:require('../assets/carpool/seat-forward-circle.png'),name:'Asiento\ndelantero'},
	//       'baby_seat': {icon:require('../assets/carpool/seat-babies-circle.png'),name:'Fumador'},
	//       'pets': {icon:require('../assets/carpool/paw-circle.png'),name:'Pet\nfriendly'},
	//   },
	//   prefIconsGrey: {
	//       'ciga': {icon:require('../assets/carpool/cigerette-grey-circle.png'),name:'Fumador'},
	//       'music': {icon:require('../assets/carpool/music-grey-circle.png'),name:'Música'},
	//       'only_girl': {icon:require('../assets/carpool/girl-grey-circle.png'),name:'Solo mujeres'},
	//       'ac': {icon:require('../assets/carpool/ac-grey-circle.png'),name:'A / C'},
	//       'luggage': {icon:require('../assets/carpool/luggage-grey-circle.png'),name:'Equipaje'},
	//       'conversation': {icon:require('../assets/carpool/chat-grey-circle.png'),name:'Conversación'},
	//       'front_seat': {icon:require('../assets/carpool/seat-forward-grey-circle.png'),name:'Asiento\ndelantero'},
	//       'baby_seat': {icon:require('../assets/carpool/seat-babies-grey-circle.png'),name:'Fumador'},
	//       'pets': {icon:require('../assets/carpool/paw-grey-circle.png'),name:'Pet\nfriendly'},
	//   },
	show3AddressWords: address => {
		let retAdd = [];
		if (address) {
			let addArr = address.split(',');
			let i = 0;
			for (let a of addArr) {
				if (a && i < 3) retAdd.push(a);
				i++;
			}
		}
		return retAdd.join(',');
	},
	// this was the old code
	// makeServiceDetailsApi: serviceDetails => {
	//   try {
	//     let floor = serviceDetails.bus_layout.floor;
	//     let floorArr = [];
	//     let lowerFloor = [];
	//     let upperFloor = [];
	//     let seat_details = [];

	//     let available = [];
	//     let availableFloor = [];
	//     let availableArr;
	//     let availableArrFloor = [];
	//     let availableSeats = 0;
	//     // if (!CommonService.isTrain()) {
	//     //   availableArr = serviceDetails.bus_layout.available.split(',');
	//     //   for (let i = 0; i < availableArr.length; i++) {
	//     //     let cell = availableArr[i].split('|');
	//     //     available.push({
	//     //       seatNumber: cell[0],
	//     //       seatFare: cell[1],
	//     //     });
	//     //     if (cell && cell[0]) {
	//     //       availableSeats++;
	//     //     }
	//     //   }
	//     // } else {
	//     availableArrFloor =
	//       serviceDetails.bus_layout.available && serviceDetails.bus_layout.available.split(':');
	//     let j = 0;
	//     for (let floor of availableArrFloor) {
	//       let availableArr = floor.split(',');
	//       availableFloor[j] = [];
	//       for (let i = 0; i < availableArr.length; i++) {
	//         let cell = availableArr[i].split('|');
	//         availableFloor[j].push({
	//           seatNumber: cell[0],
	//           seatFare: cell[1],
	//         });
	//         if (cell && cell[0]) {
	//           availableSeats++;
	//         }
	//       }
	//       j++;
	//     }
	//     // }
	//     // console.log('availableArrFloor', availableArrFloor, availableFloor);
	//     let coach_details = [];
	//     // if (!CommonService.isTrain()) {
	//     //   let rowArr = serviceDetails.bus_layout.coach_details.split(',');
	//     //   for (let i = 0; i < rowArr.length; i++) {
	//     //     let colArr = rowArr[i].split('-');
	//     //     for (let j = 0; j < colArr.length; j++) {
	//     //       let cell = colArr[j].split('|');
	//     //       coach_details.push({
	//     //         seatNumber: cell[0],
	//     //         seatType: cell[1] ? cell[1] : '',
	//     //         rowId: i,
	//     //         colId: j,
	//     //       });
	//     //     }
	//     //   }
	//     // } else {
	//     let indexOfColon = serviceDetails.bus_layout.coach_details.indexOf(':');
	//     let coachFloors = serviceDetails.bus_layout.coach_details.split(':');
	//     let floorNo = 0;
	//     for (let floor of coachFloors) {
	//       let rowArr = floor.split(',');
	//       for (let i = 0; i < rowArr.length; i++) {
	//         let colArr = rowArr[i].split('-');
	//         for (let j = 0; j < colArr.length; j++) {
	//           let cell = colArr[j].split('|');
	//           coach_details.push({
	//             seatNumber: cell[0],
	//             seatType: cell[1] ? cell[1] : '',
	//             rowId: i,
	//             colId: j,
	//             floorNo: floorNo,
	//           });
	//         }
	//       }
	//       floorNo++;
	//     }
	//     // }
	//     // console.log('coach_details', coach_details);
	//     let floors = [];
	//     if (floor) {
	//       // if (!CommonService.isTrain()) {
	//       //   if (floor.indexOf('@') >= 0) {
	//       //     floorArr = floor.split('@');
	//       //     if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
	//       //       lowerFloor = floorArr[1].split(',');
	//       //       upperFloor = floorArr[0].split(',');
	//       //     } else {
	//       //       floorArr = floor.split('@');
	//       //       lowerFloor = floorArr[0].split(',');
	//       //     }
	//       //   } else {
	//       //     lowerFloor = floor.split(',');
	//       //   }
	//       // } else {
	//       if (floor.indexOf('@') >= 0) {
	//         floorArr = floor.split('@');
	//         lowerFloor = floorArr[0] ? floorArr[0].split(',') : [];
	//         if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
	//           upperFloor = floorArr[1].split(',');
	//         }
	//         let i = 0;
	//         for (let arr of floorArr) {
	//           let seatReverse = arr ? arr.split(':') : [];
	//           floors[i] = {};
	//           if (seatReverse[0] && seatReverse[0].indexOf(',') > -1) {
	//             floors[i].normal = seatReverse[0].split(',');
	//           }
	//           if (seatReverse[1] && seatReverse[1].indexOf(',') > -1) {
	//             floors[i].reverse = seatReverse[1].split(',');
	//           }
	//           i++;
	//         }
	//       } else {
	//         lowerFloor = floor.split(',');
	//       }

	//       // if (floor.indexOf('@') >= 0 && floor.split('@')[0]) {
	//       //   floorArr = floor.split('@');
	//       //   lowerFloor = floorArr[0].split(',');
	//       //   if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
	//       //     upperFloor = floorArr[1].split(',');
	//       //   }
	//       //   let i = 0;
	//       //   for (let arr of floorArr) {
	//       //     let seatReverse = arr.split(':');
	//       //     floors[i] = {};
	//       //     if (seatReverse[0] && seatReverse[0].indexOf(',') > -1) {
	//       //       floors[i].normal = seatReverse[0].split(',');
	//       //     }
	//       //     if (seatReverse[1] && seatReverse[1].indexOf(',') > -1) {
	//       //       floors[i].reverse = seatReverse[1].split(',');
	//       //     }
	//       //     i++;
	//       //   }
	//       // } else {
	//       //   if (floor.indexOf('@')) {
	//       //     floorArr = floor.split('@');
	//       //     lowerFloor = floorArr[1].split(',')
	//       //   } else {
	//       //     lowerFloor = floor.split(',');
	//       //   }
	//       // }
	//     }
	//     // }
	//     // console.log('floors --------', floors);
	//     let seatAvailable;
	//     let noAvailableColon = serviceDetails.bus_layout.available.indexOf(':') < 0;
	//     let availableArrNoCol = serviceDetails.bus_layout.available.split(',');
	//     for (let i = 0; i < coach_details.length; i++) {
	//       let seatJson = {};
	//       let isSeat = false;
	//       let seatType = getSeatType(coach_details[i].seatType, seatIdentifiers);
	//       let isGangway = coach_details[i].seatType.indexOf('GY') >= 0 || !seatType ? true : false;
	//       let berthLower;
	//       let berthUpper;
	//       let berthType;
	//       let seatDirection;
	//       // if (!CommonService.isTrain()) {
	//       //   berthLower = lowerFloor.find(number => {
	//       //     if (number == coach_details[i].seatNumber) {
	//       //       return true;
	//       //     }
	//       //   });
	//       //   if (upperFloor) {
	//       //     berthUpper = upperFloor.find(number => {
	//       //       if (number == coach_details[i].seatNumber) {
	//       //         return true;
	//       //       }
	//       //     });
	//       //   }
	//       // } else {
	//       let floorno = 0;
	//       for (let floor of floors) {
	//         if (floorno === coach_details[i].floorNo) {
	//           let isSeatInFloorNoraml = null;
	//           let isSeatInFloorRev = null;
	//           seatDirection = null;
	//           isSeatInFloorNoraml =
	//             floor.normal &&
	//             floor.normal.find(number => {
	//               if (number == coach_details[i].seatNumber) {
	//                 return true;
	//               }
	//             });
	//           if (floor.reverse) {
	//             isSeatInFloorRev = floor.reverse.find(number => {
	//               if (number == coach_details[i].seatNumber) {
	//                 return true;
	//               }
	//             });
	//           }
	//           if (isSeatInFloorNoraml) {
	//             berthType = floorno;
	//             seatDirection = 1;
	//             break;
	//           }
	//           if (isSeatInFloorRev) {
	//             berthType = floorno;
	//             seatDirection = 2;
	//             break;
	//           }
	//         }
	//         floorno++;
	//       }
	//       // }
	//       let seatAvailable;
	//       if (!(CommonService.isTrain() || serviceDetails.travel_id == 272) && noAvailableColon) {
	//         let availableItem = availableArrNoCol.find(seat => {
	//           return seat.split('|')[0] == coach_details[i].seatNumber;
	//         });
	//         if (availableItem) {
	//           seatAvailable = {
	//             seatNumber: availableItem.split('|')[0],
	//             seatFare: availableItem.split('|')[1],
	//           };
	//         }
	//       } else {
	//         if (availableFloor[coach_details[i].floorNo]) {
	//           seatAvailable = availableFloor[coach_details[i].floorNo].find(seat => {
	//             return seat.seatNumber == coach_details[i].seatNumber;
	//           });
	//         }
	//       }
	//       if (indexOfColon < 0) {
	//         berthLower = lowerFloor.find(number => {
	//           if (number == coach_details[i].seatNumber) {
	//             return true;
	//           }
	//         });
	//         if (upperFloor) {
	//           berthUpper = upperFloor.find(number => {
	//             if (number == coach_details[i].seatNumber) {
	//               return true;
	//             }
	//           });
	//         }
	//       }
	//       let fare = seatAvailable ? seatAvailable.seatFare : null;
	//       seatJson['available'] = seatAvailable ? true : false;
	//       seatJson['fare'] = fare;
	//       seatJson['is_ladies_seat'] = false;
	//       seatJson['is_gents_seat'] = false;
	//       seatJson['type'] = seatType ? seatType : 'CLASICO';
	//       seatJson['seat_direction'] = seatDirection;
	//       seatJson['floor_no'] =
	//         indexOfColon >= 0
	//           ? coach_details[i].floorNo
	//           : berthLower
	//           ? 0
	//           : berthUpper
	//           ? 1
	//           : floor
	//           ? ''
	//           : 0;
	//       seatJson['berthType'] = berthType;
	//       // seatJson['berthType'] = CommonService.isTrain()
	//       //   ? berthType
	//       //   : berthLower
	//       //   ? 'lower'
	//       //   : berthUpper
	//       //   ? 'upper'
	//       //   : '';
	//       seatJson['number'] = coach_details[i].seatNumber;
	//       seatJson['row_id'] = coach_details[i].rowId;
	//       seatJson['col_id'] = coach_details[i].colId;
	//       seatJson['is_seat'] = true;
	//       seatJson['is_gangway'] = isGangway;
	//       seatJson['is_horizontal'] = false;
	//       if (!isGangway) {
	//         seatJson['discount_amount'] = 0;
	//         seatJson['net_amount'] = fare - seatJson['discount_amount'];
	//       }
	//       seat_details.push(seatJson);
	//     }

	//     let stages = [];
	//     let coachDetails = {
	//       total_seats: coach_details.length,
	//       available_seats: available.length,
	//       driver_position: 'left',
	//       seat_details: seat_details,
	//     };
	//     let obj = {
	//       origin: { id: +serviceDetails.origin_id },
	//       destination: { id: +serviceDetails.destination_id },
	//       available_seats: serviceDetails.available_seats,
	//       total_available_seats: availableSeats,
	//       dep_time: serviceDetails.dep_time,
	//       arr_time: serviceDetails.arr_time,
	//       duration: serviceDetails.duration,
	//       bus_type: serviceDetails.bus_type,
	//       no_of_wagons: floors.length,
	//       cost: serviceDetails.cost,
	//       coach_details: coachDetails,
	//       stage_details: stages,
	//       boarding_stages: serviceDetails.bus_layout.boarding_stages,
	//       dropoff_stages: serviceDetails.bus_layout.dropoff_stages,
	//       travel_id: serviceDetails.travel_id,
	//       res_details: serviceDetails.res_details,
	//       id: serviceDetails.id,
	//     };
	//     let retObj = JSON.parse(JSON.stringify(obj));
	//     obj = null;

	//     // console.log('seat_details', seat_details, obj);
	//     return retObj;
	//   } catch (e) {
	//     console.log('coachlayot', e);
	//     return null;
	//   }
	// },

	makeServiceDetailsApi: serviceDetails => {
		// console.log('testing serviceDetails--------', serviceDetails);
		try {
			let floor = serviceDetails.bus_layout.floor;
			let floorArr = [];
			let lowerFloor = [];
			let upperFloor = [];
			let seat_details = [];

			let available = [];
			let availableFloor = [];
			let oAvailableFloor = [];
			let availableArr;
			let oAvailableArr;
			let availableArrFloor = [];
			let oAvailableArrFloor = [];
			let availableSeats = 0;
			let oAvailableSeats = 0;
			let api_type = serviceDetails.api_type ? serviceDetails.api_type : 0;
			// if (!CommonService.isTrain()) {
			//   availableArr = serviceDetails.bus_layout.available.split(',');
			//   for (let i = 0; i < availableArr.length; i++) {
			//     let cell = availableArr[i].split('|');
			//     available.push({
			//       seatNumber: cell[0],
			//       seatFare: cell[1],
			//     });
			//     if (cell && cell[0]) {
			//       availableSeats++;
			//     }
			//   }
			// } else {
			availableArrFloor =
				serviceDetails.bus_layout.available && serviceDetails.bus_layout.available.split(':');
			oAvailableArrFloor =
				serviceDetails.bus_layout.available && serviceDetails.bus_layout.o_availabity.split(':');

			// console.log('test test oAvailableArrFloor---------', oAvailableArrFloor);
			let j = 0;
			for (let floor of availableArrFloor) {
				let availableArr = floor.split(',');
				availableFloor[j] = [];
				for (let i = 0; i < availableArr.length; i++) {
					let cell = availableArr[i].split('|');
					availableFloor[j].push({
						seatNumber: cell[0],
						seatFare: cell[1],
					});
					if (cell && cell[0]) {
						availableSeats++;
					}
				}
				j++;
			}

			let k = 0;
			for (let floor of oAvailableArrFloor) {
				let oAvailableArr = floor.split(',');
				// console.log('test test oAvailableArr---------', oAvailableArr);
				oAvailableFloor[k] = [];
				for (let i = 0; i < oAvailableArr.length; i++) {
					let cell = oAvailableArr[i].split('|');

					// console.log('test test cell---------', oAvailableArr);
					oAvailableFloor[k].push({
						seatNumber: cell[0],
						seatFare: cell[1],
					});
					if (cell && cell[0]) {
						oAvailableSeats++;
					}
				}
				k++;
			}

			// console.log('test test oAvailableFloor---------', oAvailableFloor);
			// }
			// console.log('availableArrFloor', availableArrFloor, availableFloor);
			let coach_details = [];
			let o_coach_details = [];
			// if (!CommonService.isTrain()) {
			//   let rowArr = serviceDetails.bus_layout.coach_details.split(',');
			//   for (let i = 0; i < rowArr.length; i++) {
			//     let colArr = rowArr[i].split('-');
			//     for (let j = 0; j < colArr.length; j++) {
			//       let cell = colArr[j].split('|');
			//       coach_details.push({
			//         seatNumber: cell[0],
			//         seatType: cell[1] ? cell[1] : '',
			//         rowId: i,
			//         colId: j,
			//       });
			//     }
			//   }
			// } else {
			let indexOfColon = serviceDetails.bus_layout.coach_details.indexOf(':');
			let coachFloors = serviceDetails.bus_layout.coach_details.split(':');
			let floorNo = 0;
			for (let floor of coachFloors) {
				let rowArr = floor.split(',');
				for (let i = 0; i < rowArr.length; i++) {
					let colArr = rowArr[i].split('-');
					for (let j = 0; j < colArr.length; j++) {
						let cell = colArr[j].split('|');
						console.log('Cell is-----', cell);
						coach_details.push({
							seatNumber: cell[0],
							seatType: cell[1] ? cell[1] : '',
							rowId: i,
							colId: j,
							floorNo: floorNo,
						});
					}
				}
				floorNo++;
			}
			// }
			// console.log('coach_details', coach_details);
			let floors = [];
			if (floor) {
				// if (!CommonService.isTrain()) {
				//   if (floor.indexOf('@') >= 0) {
				//     floorArr = floor.split('@');
				//     if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
				//       lowerFloor = floorArr[1].split(',');
				//       upperFloor = floorArr[0].split(',');
				//     } else {
				//       floorArr = floor.split('@');
				//       lowerFloor = floorArr[0].split(',');
				//     }
				//   } else {
				//     lowerFloor = floor.split(',');
				//   }
				// } else {
				if (floor.indexOf('@') >= 0) {
					floorArr = floor.split('@');
					lowerFloor = floorArr[0] ? floorArr[0].split(',') : [];
					if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
						upperFloor = floorArr[1].split(',');
					}
					let i = 0;
					for (let arr of floorArr) {
						let seatReverse = arr ? arr.split(':') : [];
						floors[i] = {};
						if (seatReverse[0] && seatReverse[0].indexOf(',') > -1) {
							floors[i].normal = seatReverse[0].split(',');
						}
						if (seatReverse[1] && seatReverse[1].indexOf(',') > -1) {
							floors[i].reverse = seatReverse[1].split(',');
						}
						i++;
					}
				} else {
					lowerFloor = floor.split(',');
				}

				// if (floor.indexOf('@') >= 0 && floor.split('@')[0]) {
				//   floorArr = floor.split('@');
				//   lowerFloor = floorArr[0].split(',');
				//   if (floorArr[1] && floorArr[1].indexOf(',') > -1) {
				//     upperFloor = floorArr[1].split(',');
				//   }
				//   let i = 0;
				//   for (let arr of floorArr) {
				//     let seatReverse = arr.split(':');
				//     floors[i] = {};
				//     if (seatReverse[0] && seatReverse[0].indexOf(',') > -1) {
				//       floors[i].normal = seatReverse[0].split(',');
				//     }
				//     if (seatReverse[1] && seatReverse[1].indexOf(',') > -1) {
				//       floors[i].reverse = seatReverse[1].split(',');
				//     }
				//     i++;
				//   }
				// } else {
				//   if (floor.indexOf('@')) {
				//     floorArr = floor.split('@');
				//     lowerFloor = floorArr[1].split(',')
				//   } else {
				//     lowerFloor = floor.split(',');
				//   }
				// }
			}
			// }
			// console.log('floors --------', floors);
			let seatAvailable;
			let noAvailableColon = serviceDetails.bus_layout.available.indexOf(':') < 0;
			let availableArrNoCol = serviceDetails.bus_layout.available.split(',');

			let oNoAvailableColon = serviceDetails.bus_layout.o_availabity.indexOf(':') < 0;
			let oAvailableArrNoCol = serviceDetails.bus_layout.o_availabity.split(',');
			for (let i = 0; i < coach_details.length; i++) {
				let seatJson = {};
				let isSeat = false;
				let seatType = getSeatType(coach_details[i].seatType, seatIdentifiers);
				let isGangway = coach_details[i].seatType.indexOf('GY') >= 0 || !seatType ? true : false;
				let berthLower;
				let berthUpper;
				let berthType;
				let seatDirection;
				// if (!CommonService.isTrain()) {
				//   berthLower = lowerFloor.find(number => {
				//     if (number == coach_details[i].seatNumber) {
				//       return true;
				//     }
				//   });
				//   if (upperFloor) {
				//     berthUpper = upperFloor.find(number => {
				//       if (number == coach_details[i].seatNumber) {
				//         return true;
				//       }
				//     });
				//   }
				// } else {
				let floorno = 0;
				for (let floor of floors) {
					if (floorno === coach_details[i].floorNo) {
						let isSeatInFloorNoraml = null;
						let isSeatInFloorRev = null;
						seatDirection = null;
						isSeatInFloorNoraml =
							floor.normal &&
							floor.normal.find(number => {
								if (number == coach_details[i].seatNumber) {
									return true;
								}
							});
						if (floor.reverse) {
							isSeatInFloorRev = floor.reverse.find(number => {
								if (number == coach_details[i].seatNumber) {
									return true;
								}
							});
						}
						if (isSeatInFloorNoraml) {
							berthType = floorno;
							seatDirection = 1;
							break;
						}
						if (isSeatInFloorRev) {
							berthType = floorno;
							seatDirection = 2;
							break;
						}
					}
					floorno++;
				}
				// }
				let seatAvailable;
				let oSeatAvailable;
				if (!(CommonService.isTrain() || serviceDetails.travel_id == 272) && noAvailableColon) {
					let availableItem = availableArrNoCol.find(seat => {
						return seat.split('|')[0] == coach_details[i].seatNumber;
					});
					if (availableItem) {
						seatAvailable = {
							seatNumber: availableItem.split('|')[0],
							seatFare: availableItem.split('|')[1],
						};
					}
					// console.log('test test seatAvailable---------', seatAvailable);

					let oAvailableItem = oAvailableArrNoCol.find(seat => {
						return seat.split('|')[0] == coach_details[i].seatNumber;
					});
					if (oAvailableItem) {
						oSeatAvailable = {
							seatNumber: oAvailableItem.split('|')[0],
							seatFare: oAvailableItem.split('|')[1],
						};
					}
					// console.log('test test oSeatAvailable---------', oSeatAvailable);
				} else {
					if (availableFloor[coach_details[i].floorNo]) {
						seatAvailable = availableFloor[coach_details[i].floorNo].find(seat => {
							return seat.seatNumber == coach_details[i].seatNumber;
						});

						oSeatAvailable = availableFloor[coach_details[i].floorNo].find(seat => {
							return seat.seatNumber == coach_details[i].seatNumber;
						});
					}
				}
				if (indexOfColon < 0) {
					berthLower = lowerFloor.find(number => {
						if (number == coach_details[i].seatNumber) {
							return true;
						}
					});
					if (upperFloor) {
						berthUpper = upperFloor.find(number => {
							if (number == coach_details[i].seatNumber) {
								return true;
							}
						});
					}
				}
				let fare = seatAvailable ? seatAvailable.seatFare : null;
				let oFare = oSeatAvailable ? oSeatAvailable.seatFare : null;
				console.log('test test oSeatAvailable is----', oSeatAvailable);
				console.log('test test oFare is----', oFare);

				seatJson['available'] = seatAvailable ? true : false;
				seatJson['fare'] = fare;
				seatJson['o_fare'] = oFare;
				seatJson['is_ladies_seat'] = false;
				seatJson['is_gents_seat'] = false;
				seatJson['type'] = seatType ? seatType : 'SALON CAMA';
				seatJson['seat_direction'] = seatDirection;
				seatJson['floor_no'] =
					indexOfColon >= 0
						? coach_details[i].floorNo
						: berthLower
							? 0
							: berthUpper
								? 1
								: floor
									? ''
									: 0;
				seatJson['berthType'] = berthType;
				// seatJson['berthType'] = CommonService.isTrain()
				//   ? berthType
				//   : berthLower
				//   ? 'lower'
				//   : berthUpper
				//   ? 'upper'
				//   : '';
				seatJson['number'] = coach_details[i].seatNumber;
				seatJson['row_id'] = coach_details[i].rowId;
				seatJson['col_id'] = coach_details[i].colId;
				seatJson['is_seat'] = true;
				seatJson['is_gangway'] = isGangway;
				seatJson['is_horizontal'] = false;
				if (!isGangway) {
					seatJson['discount_amount'] = 0;
					seatJson['net_amount'] = fare - seatJson['discount_amount'];
				}
				seat_details.push(seatJson);
			}

			let stages = [];
			let coachDetails = {
				total_seats: coach_details.length,
				available_seats: available.length,
				driver_position: 'left',
				seat_details: seat_details,
			};
			let obj = {
				origin: { id: +serviceDetails.origin_id },
				destination: { id: +serviceDetails.destination_id },
				available_seats: serviceDetails.available_seats,
				total_available_seats: availableSeats,
				dep_time: serviceDetails.dep_time,
				arr_time: serviceDetails.arr_time,
				duration: serviceDetails.duration,
				bus_type: serviceDetails.bus_type,
				no_of_wagons: floors.length,
				cost: serviceDetails.cost,
				coach_details: coachDetails,
				stage_details: stages,
				boarding_stages: serviceDetails.bus_layout.boarding_stages,
				dropoff_stages: serviceDetails.bus_layout.dropoff_stages,
				travel_id: serviceDetails.travel_id,
				res_details: serviceDetails.res_details,
				id: serviceDetails.id,
				api_type: api_type,
			};
			let retObj = JSON.parse(JSON.stringify(obj));
			obj = null;

			// console.log('seat_details', seat_details, obj);
			return retObj;
		} catch (e) {
			console.log('coachlayot', e);
			return null;
		}
	},
	setSeatLayout: (serviceDetails, route) => {
		try {
			let coachLayoutJson = [];
			let upperAvalibility;
			let originStageDetails;
			let destinationStageDetails;

			let errorMessage;
			if (serviceDetails.code === 416) {
				errorMessage = serviceDetails.message;
			} else {
				let seatDetails = serviceDetails.coach_details.seat_details;
				for (let seat of seatDetails) {
					if (!(CommonService.isTrain() || serviceDetails.travel_id == 272)) {
						if (typeof coachLayoutJson[seat.row_id] == 'undefined') {
							coachLayoutJson[seat.row_id] = [];
						}
					} else {
						if (typeof coachLayoutJson[seat.floor_no] == 'undefined') {
							coachLayoutJson[seat.floor_no] = [];
						}
						if (typeof coachLayoutJson[seat.floor_no][seat.row_id] == 'undefined') {
							coachLayoutJson[seat.floor_no][seat.row_id] = [];
						}
					}
					let currentSeatJson = {};

					let berthTextPos = seat.type.indexOf('Berth');
					currentSeatJson.rowSpan = berthTextPos !== -1 ? 2 : 1;
					currentSeatJson.isBerth = berthTextPos !== -1 ? true : false;
					currentSeatJson.isReservable = seat.available;
					currentSeatJson.berthType = seat.berthType;
					currentSeatJson.isUpper = seat.floor_no ? seat.floor_no === 1 : false;
					if (currentSeatJson.isUpper) {
						upperAvalibility = currentSeatJson.isUpper;
					}
					currentSeatJson.isLower = !currentSeatJson.isUpper;
					currentSeatJson.object = seat;
					currentSeatJson.number = seat.number;
					currentSeatJson.isLadiesSeat = seat.is_ladies_seat;
					currentSeatJson.isGentsSeat = seat.is_gents_seat;
					currentSeatJson.type = seat.type;
					currentSeatJson.isGangWay = seat.type.indexOf('Gang') !== -1;
					currentSeatJson.isBreak = seat.type.indexOf('Break') !== -1;
					currentSeatJson.isSelected = false;
					if (!(CommonService.isTrain() || serviceDetails.travel_id == 272)) {
						coachLayoutJson[seat.row_id][seat.col_id] = currentSeatJson;
					} else {
						coachLayoutJson[seat.floor_no][seat.row_id][seat.col_id] = currentSeatJson;
					}
				}
				originStageDetails = serviceDetails.boarding_stages;
				destinationStageDetails = serviceDetails.dropoff_stages;
				let boardingStage = originStageDetails.length == 1 ? originStageDetails[0] : null;
				let droppingStage = destinationStageDetails.length == 1 ? destinationStageDetails[0] : null;

				return {
					coachLayoutJson: coachLayoutJson,
					originStageDetails: originStageDetails,
					destinationStageDetails: destinationStageDetails,
					boardingStage: boardingStage,
					droppingStage: droppingStage,
					upperAvalibility: upperAvalibility,
					route: route,
					api_type: serviceDetails.api_type,
				};
			}
		} catch (e) {
			console.log(
				'Exception in seat-laout.ts --> defaultCall() --> apiFactory.getServiceDetails(path)',
				e,
			);
		}
	},
	transpose: matrix => {
		return matrix.reduce(
			(prev, next) => next.map((item, i) => (prev[i] || []).concat(next[i])),
			[],
		);
	},
	selectSeat: (
		seat,
		metaData,
		coachLayout,
		selectedSeatsToBook,
		selectedService,
		operator,
		isMot,
	) => {
		// console.log('operator is--', operator);
		let maxSeats =
			metaData && metaData.max_seats_allowed_by_op[operator.operator_id]
				? metaData.max_seats_allowed_by_op[operator.operator_id]
				: metaData.max_seats_allowed;
		if (isMot) {
			maxSeats = 1;
		}

		if (!seat.object.available) {
			return 'NO_AVAILABLE';
		}
		try {
			CommonService.googleProductClick(
				CommonService.convertBusServiceToGoogleProduct(
					seat.object,
					selectedService,
					CommonService.isTrain() ? 'train' : 'bus',
				),
			);

			let bookingDetails = {};
			let currentSeat = seat;
			let selectedSeatsNumbers = '';
			selectedSeatsToBook = JSON.parse(
				JSON.stringify(selectedSeatsToBook ? selectedSeatsToBook : []),
			);
			let currentSeatJson = coachLayout[currentSeat['object'].row_id][currentSeat['object'].col_id];

			if (selectedSeatsToBook.length < maxSeats || currentSeatJson.isSelected) {
				currentSeatJson.isSelected = !currentSeatJson.isSelected;
				if (currentSeatJson.isSelected) {
					selectedSeatsToBook.push(seat.object);
				} else {
					selectedSeatsToBook.splice(
						selectedSeatsToBook.findIndex(item => {
							if (item.number === seat.object.number) {
								item.passengerName = '';
								item.age = '';
							}
							return item.number === seat.object.number;
						}),
						1,
					);
				}
				let totalBookingAmount = 0;
				let oTotalBookingAmount = 0;
				let selectedSeats = [];

				let selectedSeatTypes = {};
				for (var i = 0; i < selectedSeatsToBook.length; i++) {
					totalBookingAmount += +selectedSeatsToBook[i].fare;
					oTotalBookingAmount += +selectedSeatsToBook[i].o_fare;

					// selectedSeats.push( (CommonService.isTrain() ? ((selectedSeatsToBook[i].floor_no+1)+'_') : '') + selectedSeatsToBook[i].number);
					selectedSeats.push(
						selectedSeatsToBook[i].floor_no + 1 + '_' + selectedSeatsToBook[i].number,
					);
					if (!selectedSeatTypes[selectedSeatsToBook[i].type]) {
						selectedSeatTypes[selectedSeatsToBook[i].type] = [];
					}
					selectedSeatTypes[selectedSeatsToBook[i].type].push(selectedSeatsToBook[i]);
				}
				for (let key in selectedSeatTypes) {
					let seatNumbers = [];
					for (let type of selectedSeatTypes[key]) {
						seatNumbers.push(type.number);
					}
					selectedSeatTypes[key][0]['seatNumbers'] = seatNumbers.join(',');
				}
				selectedSeatsNumbers = selectedSeats.join(',');
				// discountAmount = this.commonService.calculateAmountByPercentage(totalBookingAmount,metaData.discountPercentage);

				let discountAmount = 0;
				let netBookingAmount = totalBookingAmount - discountAmount;

				// -------------------- Fare charges details --------------------
				bookingDetails.totalBookingAmount = totalBookingAmount;
				bookingDetails.oTotalBookingAmount = oTotalBookingAmount;
				bookingDetails.netBookingAmount = netBookingAmount;
				bookingDetails.discountAmount = discountAmount;
				bookingDetails.selectedSeatsToBook = selectedSeatsToBook;
				bookingDetails.selectedSeatsNumbers = selectedSeatsNumbers;
				bookingDetails.selectedSeatTypes = selectedSeatTypes;
				return bookingDetails;
			} else {
				return 'MAX_SEATS_ERROR';
				// console.log('Maximum Number of Seat Selection is reached');
				// this.util.showToast(this.util.tranlateInstant("max_four_seats_allowed"));
			}
		} catch (e) {
			console.log('SelectseatsController_selectSeatFunction', e);
		}
	},

	selectPetSeat: (seat, seat2, metaData, coachLayout, selectedSeatsToBook, selectedService) => {
		// console.log(seat);

		if (!seat.object.available) {
			return 'NO_AVAILABLE';
		}
		try {
			CommonService.googleProductClick(
				CommonService.convertBusServiceToGoogleProduct(
					seat.object,
					selectedService,
					CommonService.isTrain() ? 'train' : 'bus',
				),
			);

			let bookingDetails = {};
			let currentSeat = seat;
			let currentSeat2 = seat2;
			let selectedSeatsNumbers = '';
			selectedSeatsToBook = JSON.parse(
				JSON.stringify(selectedSeatsToBook ? selectedSeatsToBook : []),
			);
			let currentSeatJson = coachLayout[currentSeat['object'].row_id][currentSeat['object'].col_id];
			let currentSeatJson2 =
				coachLayout[currentSeat2['object'].row_id][currentSeat2['object'].col_id];

			if (
				selectedSeatsToBook.length < (metaData ? metaData.max_seats_allowed : 6) ||
				currentSeatJson.isSelected
			) {
				currentSeatJson.isSelected = !currentSeatJson.isSelected;
				currentSeatJson2.isSelected = !currentSeatJson2.isSelected;
				seat.object.is_pet_seat = true;
				seat.object.associated_seat = seat2.object.number;
				seat.object.pet_seat_type = 'primary';
				seat2.object.pet_seat_type = 'secondary';
				if (currentSeatJson.isSelected) {
					selectedSeatsToBook.push(seat.object);
					selectedSeatsToBook.push(seat2.object);
				} else {
					selectedSeatsToBook.splice(
						selectedSeatsToBook.findIndex(item => {
							if (item.number === seat.object.number) {
								item.passengerName = '';
								item.age = '';
							}
							return item.number === seat.object.number;
						}),
						1,
					);
					selectedSeatsToBook.splice(
						selectedSeatsToBook.findIndex(item => {
							if (item.number === seat2.object.number) {
								item.passengerName = '';
								item.age = '';
							}
							return item.number === seat2.object.number;
						}),
						1,
					);
				}
				let totalBookingAmount = 0;
				let oTotalBookingAmount = 0;
				let selectedSeats = [];
				let selectedSeatTypes = {};
				for (var i = 0; i < selectedSeatsToBook.length; i++) {
					totalBookingAmount += +selectedSeatsToBook[i].fare;
					oTotalBookingAmount += +selectedSeatsToBook[i].o_fare;
					// selectedSeats.push( (CommonService.isTrain() ? ((selectedSeatsToBook[i].floor_no+1)+'_') : '') + selectedSeatsToBook[i].number);
					selectedSeats.push(
						selectedSeatsToBook[i].floor_no + 1 + '_' + selectedSeatsToBook[i].number,
					);
					if (!selectedSeatTypes[selectedSeatsToBook[i].type]) {
						selectedSeatTypes[selectedSeatsToBook[i].type] = [];
					}
					selectedSeatTypes[selectedSeatsToBook[i].type].push(selectedSeatsToBook[i]);
				}
				for (let key in selectedSeatTypes) {
					let seatNumbers = [];
					for (let type of selectedSeatTypes[key]) {
						seatNumbers.push(type.number);
					}
					selectedSeatTypes[key][0]['seatNumbers'] = seatNumbers.join(',');
				}
				selectedSeatsNumbers = selectedSeats.join(',');
				// discountAmount = this.commonService.calculateAmountByPercentage(totalBookingAmount,metaData.discountPercentage);

				let discountAmount = 0;
				let netBookingAmount = totalBookingAmount - discountAmount;

				// -------------------- Fare charges details --------------------
				bookingDetails.totalBookingAmount = totalBookingAmount;
				bookingDetails.oTotalBookingAmount = oTotalBookingAmount;
				bookingDetails.netBookingAmount = netBookingAmount;
				bookingDetails.discountAmount = discountAmount;
				bookingDetails.selectedSeatsToBook = selectedSeatsToBook;
				bookingDetails.selectedSeatsNumbers = selectedSeatsNumbers;
				bookingDetails.selectedSeatTypes = selectedSeatTypes;
				return bookingDetails;
			} else {
				return 'MAX_SEATS_ERROR';
				// console.log('Maximum Number of Seat Selection is reached');
				// this.util.showToast(this.util.tranlateInstant("max_four_seats_allowed"));
			}
		} catch (e) {
			console.log('SelectseatsController_selectSeatFunction', e);
		}
	},

	setLocal: (key, val) => {
		localStorage.setItem(key, JSON.stringify(val));
	},

	getLocal: key => {
		// console.log({key})
		let val = localStorage.getItem(key);
		// console.log({val})
		if (val !== 'undefined') {
			return JSON.parse(val);
		} else {
			return [];
		}
	},
	removeLocal: key => {
		let val = localStorage.removeItem(key);
	},

	getServiceFilters: (routes, metaData, op) => {
		console.log('getServiceFilters', metaData);
		let filters = {
			operators: {
				title: 'BUS_COMAPNIES',
				type: 'operator',
				options: [],
			},
			seatTypes: {
				title: 'SEAT_TYPES',
				type: 'seat_types',
				options: [],
			},
			amenities: {
				title: 'AMENITIES',
				type: 'amenities',
				// options: [
				//   { trText: 'CHARGING_PLUG', label: 'Charging Plug', value: 'charging_plug' },
				//   { trText: 'MOBILE_TICKET', label: 'Wifi', value: 'mobile_ticket' },
				//   { trText: 'WIFI', label: 'Snacks New', value: 'wifi' },
				//   { trText: 'SNACKS_NEW', label: 'Mobile Ticket', value: 'snacks_new' },
				// ],
				options: [],
			},
		};
		let seatTypes = [];
		let operators = [];
		let amenities = [];
		for (let r of routes) {
			let fareStr = r.fare_str.split(',');
			for (let f of fareStr) {
				let type = f
					.split(':')[0]
					.replace(/ /g, '-')
					.toLowerCase();
				let type2;
				if (type.toLowerCase().indexOf('semi') > -1) {
					type2 = 'Semi Cama';
				} else if (type.toLowerCase().indexOf('vent') > -1) {
					type2 = 'Salon Sin Vent';
				} else if (type.toLowerCase().indexOf('salon') > -1) {
					type2 = 'Salon Cama';
				} else if (type.toLowerCase().indexOf('ejecutivo') > -1) {
					type2 = 'Cama Ejecutivo';
				} else if (type.toLowerCase().indexOf('suite') > -1) {
					type2 = 'Cama Suite';
				} else if (type.toLowerCase().indexOf('vip') > -1) {
					type2 = 'Cama VIP';
				} else if (type.toLowerCase().indexOf('preferente') > -1) {
					type2 = 'Preferente';
				} else if (type.toLowerCase() == 'cama') {
					type2 = 'Cama';
				} else if (type.toLowerCase() == 'clasico') {
					type2 = 'Clasico';
				}
				if (seatTypes.indexOf(type2) === -1) {
					seatTypes.push(type2);
				}
			}
			if (operators.indexOf(r.operator_service_name) === -1) {
				operators.push(r.operator_service_name);
			}
			if (metaData) {
				let amArr = r.operator_details[4];
				for (let a of amArr) {
					if (a) {
						let am = metaData && metaData.amenities && metaData.amenities[a] && metaData.amenities[a].split('.')[0].toLowerCase();
						if (amenities.indexOf(am) === -1) {
							amenities.push(am);
						}
					}
				}
			}
		}
		for (let s of seatTypes) {
			if (s) filters.seatTypes.options.push({ label: s.replace(/-/g, ' '), value: s });
		}
		for (let o of operators.sort()) {
			filters.operators.options.push({ label: o, value: o });
		}
		if (metaData) {
			const hasPets = op && op.is_petseat_enabled;
			hasPets &&
				filters.amenities.options.push({
					label: 'Mascota a bordo',
					value: 'pet',
				});
			for (let a of amenities) {
				if (a)
					filters.amenities.options.push({
						label: getAmenityName(
							a
								.split('.')[0]
								.split('_')
								.join(' '),
						),
						value: a,
					});
			}
		}

		return filters;
	},
	getHeaders: (carpool, isPassengerInfo) => {
		const headers = {};
		set(headers, 'category_type', '1');
		set(headers, 'Accept', 'application/json');
		set(headers, 'Content-Type', 'application/json; charset=utf-8');
		set(headers, 'language', i18next.language);
		set(headers, 'x-op-app-domain', AppData.X_OP_APP_DOMAIN);
		set(headers, 'x-opsite', AppData.X_OPSITE);
		set(headers, 'X-Api-Key', 'QHH79qF2fsWEx98pvNeZpQ');
		let key = CommonService.jwt_key;
		if (!CommonService.jwt_key) {
			key = CommonService.metaSecret(localStorage.getItem('jwt_key'), false);
		}
		set(headers, 'x-jwt-token', key);

		let x_auth_key = CommonService.x_auth_key;
		if (!CommonService.x_auth_key && typeof window !== 'undefined') {
			x_auth_key = CommonService.akd(sessionStorage.getItem('x_auth_key'), false);
		}
		set(headers, 'x-auth-key', x_auth_key ? x_auth_key.s : '');
		set(headers, 'x-auth-uuid', x_auth_key ? x_auth_key.u : '');

		var metaTagToken = document.getElementById('api-auth-token');
		var x_api_token = metaTagToken ? metaTagToken.getAttribute('content') : null;

		var metaTagKey = document.getElementById('api-auth-key');
		var x_api_key = metaTagKey ? metaTagKey.getAttribute('content') : null;

		if (AppData.generateServerData && !x_api_token) {
			let serverData = AppData.generateServerData();
			x_api_token = serverData ? serverData.signedToken : '';
			x_api_key = serverData ? serverData.key : '';
		}

		set(headers, 'x-api-auth-token', x_api_token);
		set(headers, 'x-api-auth-key', x_api_key);

		try {
			// const state = store().getState();
			// let token = GlobalService.setGlobal('token');
			console.log('global22 ----------------------------', global);
			if (global.token) {
				if (carpool) {
					if (global.userMode == 'DRIVER') {
						// set(headers, 'XKEY', global.xkey);
						// set(headers, 'XTOKEN', CommonService.generateXAccess(global.xkey, global.xtoken));
						set(headers, 'XACCESS', global.driverXAccess);
					} else {
						// set(headers, 'XKEY', global.xkey);
						// set(headers, 'XTOKEN', CommonService.generateXAccess(global.xkey, global.xtoken));
						set(headers, 'XACCESS', global.xAccess);
					}
				} else {
					set(headers, 'Authorization', global.token);
					set(headers, 'XACCESS', global.xAccess);
				}
			}
			set(headers, 'XKEY', global.xkey);
			set(headers, 'XTOKEN', CommonService.generateXAccess(global.xkey, global.xtoken));
			if (isPassengerInfo) {
				set(headers, 'x-is-psi', 'true');
			}

			return headers;
		} catch (e) {
			console.log('fffffff');
		}
	},
	getAtHeaders: () => {
		const headers = {};
		set(headers, 'Accept', 'application/json');
		set(headers, 'Content-Type', 'application/json; charset=utf-8');
		// set(
		//   headers,
		//   'Authorization',
		//   'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRoX3V1aWQiOiJmMzk3N2RmZC1iYzFkLTQ4NTQtYTRlNi1hZWE3MDA4MmZmNTMiLCJhdXRob3JpemVkIjp0cnVlLCJleHAiOjE2MTAxMDk1Njh9.fdzzUOPhIPMT6OixIxym3t9YMwRunWGit8tSZ9en7c0',
		// );
		set(headers, 'api_key', '012345678');
		return headers;
	},
	getCuponeraHeaders: () => {
		const headers = {};
		// set(headers, 'Accept', 'application/json');
		set(headers, 'Content-Type', 'application/json; charset=utf-8');
		set(headers, 'X-api-key', 'QHH79qF2fsWEx98pvNeZpQ');
		if (global.token) set(headers, 'Authorization', global.token);

		console.log({ headers });
		// set(
		//   headers,
		//   'Authorization',
		//   'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRoX3V1aWQiOiJmMzk3N2RmZC1iYzFkLTQ4NTQtYTRlNi1hZWE3MDA4MmZmNTMiLCJhdXRob3JpemVkIjp0cnVlLCJleHAiOjE2MTAxMDk1Njh9.fdzzUOPhIPMT6OixIxym3t9YMwRunWGit8tSZ9en7c0',
		// );
		// set(headers, 'api_key', '012345678');
		return headers;
	},

	getStringWithoutAccent: str => {
		if (str) {
			return str
				.toLowerCase()
				.replace('ñ', 'n')
				.replace('á', 'a')
				.replace('é', 'e')
				.replace('ó', 'o')
				.replace('í', 'i')
				.replace('ú', 'u');
		}
	},
	getAddressWithoutAccent: str => {
		// console.log("String rec is----", str)
		if (str) {
			let newStr = str
				.split('----')
				.join(',')
				.toLowerCase()
				.replace('ñ', 'n')
				.replace('á', 'a')
				.replace('é', 'e')
				.replace('ó', 'o')
				.replace('í', 'i')
				.replace('ú', 'u');
			// console.log("Converted string is------", newStr)

			return newStr;
		}
	},
	removeClass: (element, className) => {
		var classes = element.className.split(' ');
		var i = classes.indexOf(className);

		if (i >= 0) classes.splice(i, 1);
		element.className = classes.join(' ');
	},
	add: (element, name) => {
		var name, arr;
		arr = element.className.split(' ');
		if (arr.indexOf(name) == -1) {
			element.className += ' ' + name;
		}
	},
	isElementInView: el => {
		if (el) {
			var rect = el.getBoundingClientRect();

			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
				(window.innerHeight ||
					document.documentElement.clientHeight) /*or $(window).height() */ &&
				rect.right <=
				(window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
			);
		}
	},
	percentage: (number, per) => {
		return (per / 100) * number;
	},

	isTrain: () => {
		return (
			window.location.pathname.indexOf('/pasajes-tren') > -1 ||
			window.location.pathname.indexOf('/train-tickets') > -1 ||
			window.location.pathname.indexOf('/train') > -1
		);
	},
	isBookingScreen: () => {
		return window.location.pathname.indexOf('booking') > -1;
	},
	isATBookingScreen: () => {
		return (
			window.location.pathname.indexOf('transfer/payment') > -1 ||
			window.location.pathname.indexOf('transfer/payment') > -1
		);
	},
	isBusOrTrain: () => {
		return (
			window.location.pathname.indexOf('/pasajes-tren') > -1 ||
			window.location.pathname.indexOf('/train-tickets') > -1 ||
			window.location.pathname.indexOf('/pasajes-tren') > -1 ||
			window.location.pathname.indexOf('/train') > -1 ||
			window.location.pathname.indexOf('/pasajes-bus') > -1 ||
			window.location.pathname.indexOf('/bus-tickets') > -1 ||
			window.location.pathname.indexOf('/bus') > -1
		);
	},
	isHome: path => {
		if (path) {
			if (
				path == '' ||
				path == '/' ||
				path == '/es' ||
				path == '/es/pasajes-bus' ||
				path == '/es/pasajes-tren' ||
				path == '/es/traslados' ||
				path == '/es/carga-bip' ||
				path == '/es/kupos-pool' ||
				path == '/es/viajes-especiales' ||
				path == '/en' ||
				path == '/en/bus-tickets' ||
				path == '/en/train-tickets' ||
				path == '/en/transfer' ||
				path == '/en/bip-recharge' ||
				path == '/en/kupos-pool' ||
				path == '/en/private-transport' ||
				path == '/es/' ||
				path == '/es/pasajes-bus/' ||
				path == '/es/pasajes-tr/en/' ||
				path == '/es/traslados/' ||
				path == '/es/carga-bip/' ||
				path == '/es/kupos-pool/' ||
				path == '/es/viajes-especiales/' ||
				path == '/en/' ||
				path == '/en/bus-tickets/' ||
				path == '/en/train-tickets/' ||
				path == '/en/transfer/' ||
				path == '/en/bip-recharge/' ||
				path == '/en/kupos-pool/' ||
				path == '/en/private-transport/'
			)
				return true;
		}
		return false;
	},
	fillPassengerAutoData: () => {
		setTimeout(() => {
			let passengerDetailsOnward = CommonService.copyObject(
				this.props.pbPaymentDetails.passengerDetailsOnward,
			);
			passengerDetailsOnward[0].name = this.props.common.loginData
				? this.props.common.loginData.name
				: null;
			passengerDetailsOnward[0].last_name = this.props.common.loginData
				? this.props.common.loginData.last_name
				: null;
			(passengerDetailsOnward[0].idCardType =
				this.props.common.loginData && Object.keys(this.props.common.loginData).length
					? this.idCardTypes.find(it => it.value == this.props.common.loginData.identity_type)
					: this.idCardTypes.find(it => it.value == 7)),
				(passengerDetailsOnward[0].idCardNumber =
					this.props.common.loginData && Object.keys(this.props.common.loginData).length
						? this.props.common.loginData.identity_val
						: null);
			this.props.actions.setPassengerDetailsOnward(passengerDetailsOnward);

			let contactDetails = {
				countryCode: this.countrieCodes && this.countrieCodes[0] ? this.countrieCodes[0].name : '',
				mobile: this.props.common.loginData ? this.props.common.loginData.phone : null,
				email: this.props.common.loginData ? this.props.common.loginData.email : null,
				confirmEmail: this.props.common.loginData ? this.props.common.loginData.email : null,
			};
			this.props.actions.setContactDetails(contactDetails);
			CommonService.loginCallbackFunction = null;
		}, 300);
	},
	getParameterByName: (name, url) => {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
	queryToObject: query => {
		// var search = location.query.substring(1);
		return JSON.parse('{"' + query.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (
			key,
			value,
		) {
			return key === '' ? value : decodeURIComponent(value);
		});
	},

	ceilNumber: (rnum, rlength = 0) => {
		var newnumber = Math.ceil(rnum * Math.pow(10, rlength)) / Math.pow(10, rlength);
		return newnumber;
	},
	getPosition: (string, subString, index) => {
		return string ? string.split(subString, index).join(subString).length : -1;
	},
	normalizeAddress: address => {
		return address ? address.substr(0, CommonService.getPosition(address, ',', 2)) : '';
	},
	removeExtraSpacesInString: str => {
		return str ? str.replace(/  +/g, ' ') : '';
	},

	pushGoogleTagEvent: (event, data) => {
		(window.dataLayer || []).push({
			event: event,
			data,
		});
	},

	googleProductClick: productObj => {
		(window.dataLayer || []).push({
			event: 'productClick',
			ecommerce: {
				click: {
					actionField: { list: 'Search Results' }, // Optional list property.
					products: [
						{
							name: productObj.name, // Name or ID is required.
							id: productObj.id,
							price: productObj.price,
							brand: productObj.brand,
							category: productObj.category,
						},
					],
				},
			},
		});
	},

	googleProductCheckout: (products, paymentOption, couponSelected, id) => {
		(window.dataLayer || []).push({
			event: 'checkout',
			ecommerce: {
				checkout: {
					actionField: { option: paymentOption, coupon: couponSelected, id: id },
					products: products,
				},
			},
		});
	},

	googleProductPurchase: (products, paymentOption, couponSelected, affiliation, id) => {
		(window.dataLayer || []).push({
			ecommerce: {
				purchase: {
					actionField: {
						option: paymentOption,
						coupon: couponSelected,
						affiliation: affiliation,
						id: id,
					},
					products: products,
				},
			},
		});

		// console.log(
		//   'data to pass to Enhanced ecommerce----',
		//   products,
		//   paymentOption,
		//   couponSelected,
		//   affiliation,
		//   id,
		// );
	},
	googleRefund: (id, products) => {
		(window.dataLayer || []).push({
			ecommerce: {
				refund: {
					actionField: { id: id },
					products: products,
				},
			},
		});
	},

	convertBusServiceToGoogleProduct: (seat, service) => {
		// console.log('Seat received is----', seat);
		// console.log('service received is----', service);
		if (service) {
			return {
				name: service.bus_type, // Name or ID is required.
				id: service.id,
				price: seat.price,
				brand: service.operator_service_name,
				category: seat.type,
				quantity: 1,
			};
		}
	},
	encodeUrlAddress: string => {
		return string
			.toLowerCase()
			.replace(/, /g, ',')
			.split(' - ')
			.join('_')
			.replace(/ /g, '-')
			.replace(/_/g, '--');
	},
	decodeUrlAddress: string => {
		return string
			.split(',')
			.join(', ')
			.split('--')
			.join('_')
			.split('-')
			.join(' ')
			.split('_')
			.join(' - ')
			.toLowerCase();
	},

	decodeBase64: function (s) {
		var e = {},
			i,
			b = 0,
			c,
			x,
			l = 0,
			a,
			r = '',
			w = String.fromCharCode,
			L = s.length;
		var A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		for (i = 0; i < 64; i++) {
			e[A.charAt(i)] = i;
		}
		for (x = 0; x < L; x++) {
			c = e[s.charAt(x)];
			b = (b << 6) + c;
			l += 6;
			while (l >= 8) {
				((a = (b >>> (l -= 8)) & 0xff) || x < L - 2) && (r += w(a));
			}
		}
		return r;
	},
	base64url: source => {
		// Encode in classical base64
		let encodedSource = CryptoJS.enc.Base64.stringify(source);

		// Remove padding equal characters
		encodedSource = encodedSource.replace(/=+$/, '');

		// Replace characters according to base64url specifications
		encodedSource = encodedSource.replace(/\+/g, '-');
		encodedSource = encodedSource.replace(/\//g, '_');

		return encodedSource;
	},
	aesEncode: (string, k = 'somestringofexactthirtytwolength', i = '0000000000000000') => {
		var key = CryptoJS.enc.Utf8.parse(k);
		var iv = CryptoJS.enc.Utf8.parse(i);
		var encrypted = CryptoJS.AES.encrypt(string, key, {
			iv: iv,
			mode: CryptoJS.mode.CBC,
		}).toString();
		return encrypted;
	},
	aesDecode: (string, k = 'somestringofexactthirtytwolength', i = '0000000000000000') => {
		var key = CryptoJS.enc.Utf8.parse(k);
		var iv = CryptoJS.enc.Utf8.parse(i);
		var bytes = CryptoJS.AES.decrypt(string, key, { iv: iv, mode: CryptoJS.mode.CBC });
		var decrypted = bytes.toString(CryptoJS.enc.Utf8);
		return decrypted;
	},
	metaSecret: (string, store = true, delimeter) => {
		try {
			let decode64 = atob(string);
			let c = decode64.split(delimeter || '@kup' + 'os@');
			let s = CommonService.aesDecode((c[0] || '').split('\n').join(''), c[1]);
			if (store) CommonService.jwt_key = s;
			return s;
		} catch (e) { }
	},

	formatCities: cities => {
		let formattedCities = [];
		for (let city of cities) {
			formattedCities.push({
				value: city[1],
				label: city[0],
			});
		}
		return formattedCities;
	},

	createJwtFull: (data, delimeter) => {
		try {
			let secret_key = CommonService.makeId(32);
			var header = {
				alg: 'HS512',
				typ: 'JWT',
			};

			var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
			var encodedHeader = CommonService.base64url(stringifiedHeader);

			var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
			var encodedData = CommonService.base64url(stringifiedData);

			var token = encodedHeader + '.' + encodedData;

			var signature = CryptoJS.HmacSHA512(token, secret_key);
			signature = CommonService.base64url(signature);

			var signedToken = btoa(token + '.' + signature + (delimeter || '#KT02K#') + secret_key);
			return signedToken;
		} catch (e) {
			console.log('mscrpt');
		}
	},

	createJwtFull2: (data, keypos1 = 5, keypos2 = 80) => {
		try {
			let secret_key = CommonService.makeId(32);
			var header = {
				alg: 'HS512',
				typ: 'JWT',
			};

			var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
			var encodedHeader = CommonService.base64url(stringifiedHeader);

			var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
			var encodedData = CommonService.base64url(stringifiedData);

			var token = encodedHeader + '.' + encodedData;

			var signature = CryptoJS.HmacSHA512(token, secret_key);
			signature = CommonService.base64url(signature);

			var k1 = secret_key.substr(0, 16);
			var k2 = secret_key.substr(16, 16);

			var signedTokenBeforeInsert = btoa(token + '.' + signature);
			let signedToken = CommonService.insertString(signedTokenBeforeInsert, keypos1, k1);
			signedToken = CommonService.insertString(signedToken, keypos2, k2);
			// console.log({ signedToken, k1, k2, secret_key: btoa(data?.jwt_string), data, signedTokenBeforeInsert })
			return { signedToken, key: btoa(data ? data.jwt_string : '') };
		} catch (e) {
			console.log('mscrpt', e);
		}
	},
	createJwtFullAndEncrypt: (data, delimeter) => {
		try {
			let secret_key = CommonService.jwt_s || CommonService.makeId(32);
			var header = {
				alg: 'HS512',
				typ: 'JWT',
			};

			var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
			var encodedHeader = CommonService.base64url(stringifiedHeader);

			var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
			var encodedData = CommonService.base64url(stringifiedData);

			var token = encodedHeader + '.' + encodedData;

			var signature = CryptoJS.HmacSHA512(token, secret_key);
			signature = CommonService.base64url(signature);
			var jwt = token + '.' + signature;
			console.log({ jwt, secret_key });
			var encJwt = CommonService.aesEncode(jwt, secret_key);

			var signedToken = btoa(encJwt + (delimeter || '#KT02K#') + secret_key);
			return signedToken;
		} catch (e) {
			console.log('mscrpt');
		}
	},
	decryptAndParse: (token, delimeter) => {
		try {
			let jwt = CommonService.metaSecret(token, false, delimeter);
			let data = CommonService.parseJwt(jwt);
			return data;
		} catch (e) {
			console.log('mscrpt');
		}
	},
	parseJwt: token => {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(
			window
				.atob(base64)
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join(''),
		);

		return JSON.parse(jsonPayload);
	},
	makeId: length => {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < length) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		return result;
	},
	loadEncTicketDetails: (pathObj, apiCall, callback) => {
		try {
			// var decryptedPath = window.atob(encryptedData);
			// console.log('decrypted data is', decryptedPath);
			// // if (this.key) {
			// // props.data.actions.apiCall({
			// //   url: ApiUrls.ticketDetailsWithPath(decryptedPath),
			// //   callback: res => loadTicketDetailsResponse(res, encryptedData),
			// //   type: 'home',
			// // });

			// let pathObj = CommonService.queryToObject(decryptedPath);

			pathObj.app_type = 'dweb';
			pathObj.is_mobile_app = 'true';
			console.log({ pathObj });
			let data = CommonService.createJwtFullAndEncrypt(pathObj, '@kup' + 'os@');
			console.log({ data });
			apiCall({
				url: ApiUrls.ticketDetailsV3(),
				method: 'POST',
				data: { token: data },
			}).then(res => {
				console.log({ res });
				if (res && res.data && res.data.token) {
					let data = CommonService.decryptAndParse(res.data.token, '@kup' + 'os@');

					res = data;
				}
				// loadTicketDetailsResponse(res, encryptedData)
				callback(res);
			});
			// }
		} catch (e) {
			console.log('error', e);
			// window.location.replace(window.location.origin);
			// props.actions.setTicketDetails('no data')
		}
	},
	operators: {
		cormarbus: {
			pay_label: 'CormarPay',
			creditos: 'CormarCreditos',
		},
		andimar: {
			pay_label: 'AndimarPay',
			creditos: 'AndimarCreditos',
		},
		busesjm: {
			pay_label: 'JmPay',
			creditos: 'JmCreditos',
		},
		ivergrama: {
			pay_label: 'IverPay',
			creditos: 'IverCreditos',
		},
		azola: {
			pay_label: 'AzolaPay',
			creditos: 'azolaCreditos',
		},
		traveltur: {
			pay_label: 'TravelturPay',
			creditos: 'TravelturCreditos',
		},
		tacoha: {
			pay_label: 'TacohaPay',
			creditos: 'TacohaCreditos',
		},
		pullmansanandres: {
			pay_label: 'SanAndresPay',
			creditos: 'SanAndresCreditos',
		},
		tarapaca: {
			pay_label: 'TarapacaPay',
			creditos: 'TarapacaCreditos',
		},
		pullmandelsur: {
			pay_label: 'PullmanDelsurPay',
			creditos: 'PullmanDelsurCreditos',
		},
		biaggini: {
			pay_label: "BiagginiPay",
			creditos: "BiagginiCreditos",
		},
		tepual: {
			pay_label: 'TepualPay',
			creditos: 'TepualCreditos',
		},
		saopaulo: {
			pay_label: 'SaoPauloPay',
			creditos: 'SaoPauloCreditos',
		},
		viatur: {
			pay_label: 'ViaturPay',
			creditos: 'ViaturCreditos',
		},
		kennybus: {
			pay_label: 'KennyBusPay',
			creditos: 'KennyBusCreditos',
		},
		santamaria: {
			pay_label: 'SMPay',
			creditos: 'SMPayCreditos',
		},
		chilebus: {
			pay_label: 'ChilebusPay',
			creditos: 'ChilebusCreditos',
		},
		jeldres: {
			pay_label: 'JeldresPay',
			creditos: 'JeldresCreditos',
		},
		santajuana: {
			pay_label: 'SantaJuanaPay',
			creditos: 'SantaJuanaCreditos',
		},
		serenamar: {
			pay_label: 'SerenaPay',
			creditos: 'SerenaCreditos',
		},
		santarosa: {
			pay_label: 'SantaRosaPay',
			creditos: 'SantaRosaCreditos',
		},
		santarosa: {
			pay_label: 'SantaRosaPay',
			creditos: 'SantaRosaCreditos',
		},
		buseslafit: {
			pay_label: 'LafitPay',
			creditos: 'LafitCreditos',
		},
		losnavegadores: {
			pay_label: 'LosNavegadoresPay',
			creditos: 'LosNavegadoresCreditos',
		},
		basetorres: {
			pay_label: 'TorresPay',
			creditos: 'TorresCreditos',
		},
		expressonorte: {
			pay_label: 'ExpressoNortePay',
			creditos: 'ExpressoNorteCreditos',
		},
		bahiaazul: {
			pay_label: 'BahiaAzulPay',
			creditos: 'BahiaAzulCreditos',
		},
		fernandez: {
			pay_label: 'FernandezPay',
			creditos: 'FernandezCreditos',
		},
		erbuc: {
			pay_label: 'ErbucPay',
			creditos: 'ErbucCreditos',
		},
		jetsur: {
			pay_label: 'JetsurPay',
			creditos: 'JetsurCreditos',
		},
		barriaghisoni: {
			pay_label: 'BarriaGhisoniPay',
			creditos: 'BarriaGhisoniCreditos',
		},
		combarbala: {
			pay_label: 'CombarbalaPay',
			creditos: 'CombarbalaCreditos',
		},
		trrass: {
			pay_label: 'TrrassPay',
			creditos: 'TrrassCreditos',
		},
		expresosantacruz: {
			pay_label: 'ExpresoSantaCruzPay',
			creditos: 'ExpresoSantaCruzCreditos',
		},
		busesahumada: {
			pay_label: 'BusesAhumadaPay',
			creditos: 'BusesAhumadaCreditos',
		},
		sanantonio: {
			pay_label: 'SanAntonioPay',
			creditos: 'SanAntonioCreditos',
		},
		thaebus: {
			pay_label: 'ThaeBusPay',
			creditos: 'ThaeBusCreditos',
		},
		centraltour: {
			pay_label: 'CentralTourPay',
			creditos: 'CentralTourCreditos',
		},
		liquine: {
			pay_label: 'LiquinePay',
			creditos: 'LiquineCreditos',
		},
	},

	shouldPassOperatorId: operator => {
		return operator && operator.is_pay_enabled;
	},
	getOperatorId: operator => {
		return operator && operator.operator_id ? operator.operator_id : '';
	},
	getOperatorPaymentLabel: operator => {
		return (
			operator &&
			operator.is_pay_enabled &&
			CommonService.operators[operator.operator_name] &&
			CommonService.operators[operator.operator_name].pay_label
		);
	},

	getOperatorCredtiosLabel: operator => {
		return (
			operator &&
			operator.is_virtual_wallet &&
			CommonService.operators[operator.operator_name] &&
			CommonService.operators[operator.operator_name].creditos
		);
	},

	getCancelTicketRefundText: operator => {
		const pay = CommonService.getOperatorPaymentLabel(operator)
			? CommonService.getOperatorPaymentLabel(operator)
			: 'kuposPay';
		return {
			bold: `Reembolso por ${pay}:`,
			normal: `Reembolso automático a la cuenta ${pay} del cliente. Permitido únicamente para usuarios registrados en ${operator.domain_url ? operator.domain_url : ''
				} y cuyo correo esté verificado.`,
		};
	},
	insertString(originalString, index, stringToInsert) {
		return originalString.substring(0, index) + stringToInsert + originalString.substring(index);
	},
	akd: (string, store = true) => {
		try {
			if (string && string !== 'undefined') {
				let k1 = string.substr(0, 12);
				let k2 = string.substr(20, 14);
				let k3 = string.substr(string.length - 6, 6);
				let r = string
					.replace(k1, '')
					.replace(k2, '')
					.replace(k3, '');
				let str2 = CommonService.aesDecode((r || '').split('\n').join(''), k1 + k2 + k3);
				let s1 = str2.substr(5, 4);
				// str2 = str2.replace(s1, '')
				let s2 = str2.substr(142, 4);
				// str2 = str2.replace(s2, '')
				let s3 = str2.substr(93, 5);
				let s = str2
					.replace(s1, '')
					.replace(s2, '')
					.replace(s3, '');
				let jwt = CommonService.parseJwt(s);
				if (store) CommonService.x_auth_key = { s, u: jwt ? jwt.verification_string : '' };
				// console.log({s, s1, s2, s3, str2, result: s == "eyJhbGciOiJIUzUxMiJ9.IjQzYTlhZjY2LTNhY2MtNGI5Yi04ODQyLWNhMTA4ODZlZTk3MSI.VRYxbGrHB5AZXSys_dbzNxG3XipSYgRUzYLSjrl8aKaOSa84lAxUM0AA4tGjfqZcEQaeGYlTK7bOMLK3WT0UGg"})
				return { s, u: jwt ? jwt.verification_string : '' };
			}
			return {};
		} catch (e) {
			console.log(e);
		}
	},
	jwt_key: '',
	x_auth_key: '',
	newSearchFunction: null,
	clearSearchFunction: null,
	newSearchTranserFunction: null,
	loginCallbackFunction: null,
	passengerDetailsOnward: null,
	passengerDetailsReturn: null,
	passengerContactDetails: null,
};

export default CommonService;



// WEBPACK FOOTER //
// ./src/services/commonService.js